import { TAX_CABINET_CHECK_URL } from "../../constants";
import { ITaxCabinetCheckParams } from "./tax-cabinet.models";

const pad = (value: number): string => String(value).padStart(2, "0");

/**
 * Builds the tax cabinet link for one receipt, e.g.
 * …/cashregs/check?fn=4001280800&id=6853075865&date=20260513&time=173328&sm=70.00
 *
 * The timestamp is formatted in local time on purpose: ДПС indexes receipts by
 * the wall-clock time the register printed them.
 */
export const buildTaxCabinetCheckUrl = ({
  cashRegisterFn,
  receiptFn,
  issuedAt,
  total,
}: ITaxCabinetCheckParams): string => {
  const issued = new Date(issuedAt);

  const date = [
    issued.getFullYear(),
    pad(issued.getMonth() + 1),
    pad(issued.getDate()),
  ].join("");

  const time = [
    pad(issued.getHours()),
    pad(issued.getMinutes()),
    pad(issued.getSeconds()),
  ].join("");

  const params = new URLSearchParams({
    fn: cashRegisterFn,
    id: receiptFn,
    date,
    time,
    sm: total.toFixed(2),
  });

  return `${TAX_CABINET_CHECK_URL}?${params.toString()}`;
};
